import request from '@/utils/request'

const property_billApi = {
  property_bill_list: '/property_bill/',
  property_bill_create: '/property_bill/',
  property_bill_update: '/property_bill/',
  property_bill_delete: '/property_bill/',
  property_bill_payment: '/property_bill/payment/'
}

/**
 * 列表
 */
export function property_bill_list (parameter) {
  return request({
    url: property_billApi.property_bill_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function property_bill_create (parameter) {
  return request({
    url: property_billApi.property_bill_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function property_bill_update (parameter, property_bill_id) {
  return request({
    url: property_billApi.property_bill_update + property_bill_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function property_bill_delete (property_bill_id) {
  return request({
    url: property_billApi.property_bill_delete + property_bill_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 添加
 */
export function property_bill_payment (parameter) {
  return request({
    url: property_billApi.property_bill_payment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
